export const toBool = (inputString) =>{
    if(!inputString) return;
    return inputString.trim().toLowerCase() === "true";
}